{
  "WantToChat": "Want to chat?",
  "HelpPhrase": "We do too! Write to us and let us know about your troubles, compliments, or general inquiry. We will get back to you within 24 hours.",
  "TellUs": "Tell Us. how we may help you?",
  "Submit": "Submit"
}
